import { useTranslation } from 'react-i18next'

/**
 * Custom hook for internationalization
 * Provides easy access to translation functions and current language
 *
 * BudouX is automatically applied to all JA/ZH translations via i18next post-processor
 */
export function useI18n(namespace?: string | string[]) {
  const { t, i18n } = useTranslation(namespace)

  return {
    // Translation function (BudouX automatically applied for JA/ZH)
    t,
    // Current language
    language: i18n.language,
    // Change language function
    changeLanguage: i18n.changeLanguage,
    // i18n instance for advanced usage
    i18n,
  }
}

/**
 * Type-safe translation keys helper
 */
export type TranslationKey = string
